import { render, staticRenderFns } from "./iconSelect.vue?vue&type=template&id=2b733bee&scoped=true&"
import script from "./iconSelect.vue?vue&type=script&lang=ts&"
export * from "./iconSelect.vue?vue&type=script&lang=ts&"
import style0 from "./iconSelect.vue?vue&type=style&index=0&id=2b733bee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b733bee",
  null
  
)

export default component.exports